document.addEventListener("DOMContentLoaded", function () {
  const tabs = document.querySelectorAll(".size-guide-popup__tab");

  tabs.forEach((tab) => {
    tab.addEventListener("click", function () {
      const container = this.closest(".drawer__row");
      const targetTab = this.getAttribute("data-tab");

      const allTabs = container.querySelectorAll(".size-guide-popup__tab");
      const allContents = container.querySelectorAll(".size-guide-popup__content");

      // Remove active classes
      allTabs.forEach((t) => t.classList.remove("active"));
      allContents.forEach((c) => c.classList.remove("active"));

      // Add active class to the clicked tab and corresponding content
      this.classList.add("active");
      container
        .querySelector(`.size-guide-popup__content[data-tab="${targetTab}"]`)
        .classList.add("active");
    });
  });
});

// Keep the "ONLY X LEFT IN STOCK" badge in sync with the selected size and colour
document.addEventListener("DOMContentLoaded", function () {
  if (typeof subscribe !== "function" || typeof PUB_SUB_EVENTS === "undefined") return;
  subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
    var data = event && event.data;
    if (!data || !data.html || !data.sectionId) return;
    var source = data.html.getElementById("low-stock-" + data.sectionId);
    var target = document.getElementById("low-stock-" + data.sectionId);
    if (source && target) target.innerHTML = source.innerHTML;
  });
});
